import { CloudyIcon } from 'src/domains/layouts/shared/assets/icons/weather/CloudyIcon';
import { SunnyIcon } from 'src/domains/layouts/shared/assets/icons/weather/SunnyIcon';
import { OvercastIcon } from 'src/domains/layouts/shared/assets/icons/weather/OvercastIcon';
import { RainIcon } from 'src/domains/layouts/shared/assets/icons/weather/RainIcon';
import { ShowersIcon } from 'src/domains/layouts/shared/assets/icons/weather/ShowersIcon';
import { SnowIcon } from 'src/domains/layouts/shared/assets/icons/weather/SnowIcon';
import styled from '@emotion/styled';

export const CloudyIconWrapper = styled(CloudyIcon, { label: 'CloudyIconWrapper' })`
    flex: 0 0 32px;
`;

export const SunnyIconWrapper = styled(SunnyIcon, { label: 'SunnyIconWrapper' })`
    flex: 0 0 32px;
`;

export const OvercastIconWrapper = styled(OvercastIcon, { label: 'OvercastIconWrapper' })`
    flex: 0 0 32px;
`;

export const RainIconWrapper = styled(RainIcon, { label: 'RainIconWrapper' })`
    flex: 0 0 32px;
`;

export const ShowersIconWrapper = styled(ShowersIcon, { label: 'ShowersIconWrapper' })`
    flex: 0 0 32px;
`;

export const SnowIconWrapper = styled(SnowIcon, { label: 'SnowIconWrapper' })`
    flex: 0 0 32px;
`;
